import styled from "styled-components";
import "./styles.css";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { AgGridReact } from "ag-grid-react"; // AG Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import {
  Button,
  Card,
  Dropdown,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import {
  clearLocalStorage,
  getLocalStorage,
  setLocalStorage,
} from "./utils/StoreState";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import IconButton from "components/common/IconButton";
import { useNavigate } from "react-router-dom";
import CardDropdown from "components/common/CardDropdown";
import { MdDeleteOutline, MdOutlineModeEdit } from "react-icons/md";
import { BsDot } from "react-icons/bs";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
import { ContactsAPI, LibraryAPI } from "api";
import { CONSTANT_ROUTES } from "routes";
import { Checkbox } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { customSettings } from "utils/customConfig";

export default function PatientsTable() {
  let isDarkBool = localStorage.getItem("isDark") === true;
  let isDarkTheme = localStorage.getItem("theme") === "dark";
  let auto = localStorage.getItem("theme") === "auto";
  const navigate = useNavigate();
  const columnApiRef = useRef();
  const gridRef = useRef();
  // let gridApi;
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  const [selectedItems, setSelectedItems] = useState([]);
  const [columnCustom, setColumnCustom] = useState([]);
  const [theme, setTheme] = useState();
  // const [gridApi, setGridApi] = useState();
  // const [columnApi, setColumnApi] = useState();

  const [rowData, setRowData] = useState([
    // { id: "1", type: "ABC", name: "Model Y" },
  ]);

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState([
    // { field: "", filter: false, headerName: "Select" },

    { field: "name", headerName: "Name", hide: false },
    { field: "age", headerName: "Age", hide: false },
    { field: "gender", headerName: "Gender", hide: false },
    { field: "phone", headerName: "Phone", hide: false },
    {
      field: "email",
      headerName: "Email",
      hide: false,
      cellStyle: {
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    // {
    //   field: "mobile",
    //   headerName: "Mobile",
    //   hide: false,
    //   cellStyle: {
    //     whiteSpace: "normal",
    //     overflow: "hidden",
    //     textOverflow: "ellipsis",
    //   },
    // },
    // {
    //   field: "email",
    //   headerName: "Email",
    //   hide: false,
    //   cellStyle: {
    //     whiteSpace: "normal",
    //     overflow: "hidden",
    //     textOverflow: "ellipsis",
    //   },
    // },
    // { field: "designation", headerName: "Designation", hide: false },
    // { field: "gender", headerName: "Gender", hide: false },
    // {
    //   field: "dob",
    //   headerName: "Date of Birth",
    //   hide: false,
    //   cellStyle: {
    //     whiteSpace: "normal",
    //     overflow: "hidden",
    //     textOverflow: "ellipsis",
    //   },
    // },
    // {
    //   field: "address",
    //   headerName: "Address",
    //   hide: false,
    //   cellStyle: {
    //     whiteSpace: "normal",
    //     overflow: "hidden",
    //     textOverflow: "ellipsis",
    //   },
    // },
    // { field: "country", headerName: "Country", hide: false },
    // { field: "state", headerName: "State", hide: false },
    // { field: "city", headerName: "City", hide: false },
    // { field: "zipCode", headerName: "Zip", hide: false },
    {
      field: "active",
      headerName: "Active",
      hide: false,
      cellStyle: {
        display: "flex",
        // paddingRight: "30px",
        justifyContent: "center",
      },
      headerClass: "center-header",
      cellRenderer: (p) => <Checkbox checked={p?.data.active} />,
    },
    {
      headerName: "Action",
      field: "action",
      maxWidth: 120,
      filter: false,
      cellRenderer: (p) => (
        <CardDropdown>
          <div className="py-2">
            <Dropdown.Item
              // as={Link}
              onClick={() => handleRowClick(p.data)}
              // href="/products/add-product"
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <MdOutlineModeEdit />
              Edit
            </Dropdown.Item>
            {/* <Dropdown.Item
              onClick={() => handleDelete(p.data)}
              className="d-flex align-items-center gap-2 py-0"
            >
              <MdDeleteOutline />
              Delete
            </Dropdown.Item> */}
            <Dropdown.Item
              onClick={() => handleMedicalProblemClick(p.data)}
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <BsDot size={15} />
              Medical Problem
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleAllergiesClick(p.data)}
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <BsDot size={15} />
              Allergies
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleMedicationClick(p.data)}
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <BsDot size={15} />
              Medications
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleVisitClick(p.data)}
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <BsDot size={15} />
              Visit
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleHistoryClick(p.data)}
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <BsDot size={15} />
              History
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleLabReportsClick(p.data)}
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <BsDot size={15} />
              Lab Reports
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleVitalsClick(p.data)}
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <BsDot size={15} />
              Vitals
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleAppointmentsClick(p.data)}
              className="d-flex align-items-center gap-2 py-0"
              style={{ height: "32px" }}
            >
              <BsDot size={15} />
              Appointments
            </Dropdown.Item>
          </div>
        </CardDropdown>
      ),
    },
  ]);

  const handleRowClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, { state: data });
    }
  };

  const getData = async () => {
    const response = await ContactsAPI.get({ params: { entityID: 0 } });
    return response?.data?.data;
  };

  const handleDelete = async (info) => {
    console.log(info);
    try {
      await ContactsAPI.delete(info.id);
      toast.success("Record Deleted Successfully", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      const newData = await getData();
      gridApi.setGridOption("rowData", newData);
    } catch (error) {
      console.log(error);
      toast.error("Something went Wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
    }
  };

  const handleMedicalProblemClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, {
        state: { ...data, tabIndex: "medical-problems" },
      });
    }
  };
  const handleAllergiesClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, {
        state: { ...data, tabIndex: "allergies" },
      });
    }
  };
  const handleMedicationClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, {
        state: { ...data, tabIndex: "medication" },
      });
    }
  };
  const handleVisitClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, {
        state: { ...data, tabIndex: "visits" },
      });
    }
  };
  const handleHistoryClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, {
        state: { ...data, tabIndex: "history" },
      });
    }
  };
  const handleLabReportsClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, {
        state: { ...data, tabIndex: "labReports" },
      });
    }
  };
  const handleVitalsClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, {
        state: { ...data, tabIndex: "vitals" },
      });
    }
  };
  const handleAppointmentsClick = (data) => {
    if (data) {
      navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT, {
        state: { ...data, tabIndex: "appointments" },
      });
    }
  };

  const defaultColDef = {
    sortable: true,
    filter: false,
    // floatingFilter: true,
    flex: 1,
    // rowDrag: true,
  };

  //   ===============Custom Api Call start================

  let gridApi;
  let columnApi;

  const onGridReady = useCallback(
    async (e) => {
      gridApi = e.api;
      columnApi = e.columnApi;
      restoreState();
      // ContactsAPI.get({ params: { entityID: 0 } })
      const data = await getData();
      e.api.applyTransaction({ add: data });

      // getData().then((res) => {
      //   console.log(res.data.data);
      //   e.api.applyTransaction({ add: res?.data?.data });
      // });
    },
    [window]
  );

  const saveState = useCallback(() => {
    const colState = columnApiRef.current.api.getColumnState();
    setLocalStorage(colState);
    console.log("column state saved");
  }, []);

  const restoreState = useCallback(() => {
    const colState = getLocalStorage();
    if (!colState) {
      console.log("no columns state to restore by, you must save state first");
      return;
    }
    columnApiRef.current.api.applyColumnState({
      state: colState,
      applyOrder: true,
    });
    console.log("column state restored");
  }, []);

  const resetState = useCallback(() => {
    columnApiRef.current.api.resetColumnState();
    clearLocalStorage();
    console.log("column state reset");
  }, []);

  const onFilterTextBoxChanged = useCallback(() => {
    columnApiRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);

  // useEffect(() => {
  //   let isDarkBool = localStorage.getItem("isDark") === true;
  //   let isDarkTheme = localStorage.getItem("theme") === "dark";
  //   let auto = localStorage.getItem("theme") === "auto";

  //   if (isDarkBool || isDarkTheme || auto) {
  //     setTheme("ag-theme-quartz-dark");
  //   } else {
  //     setTheme("ag-theme-quartz");
  //   }
  // }, [localStorage.getItem("isDark") || localStorage.getItem("theme")]);

  // console.log(theme);

  return (
    <div>
      <div className="py-2">
        <BreadCrumb />
      </div>

      <div
        className={`${
          isDarkBool || isDarkTheme || auto
            ? "ag-theme-quartz-dark"
            : "ag-theme-quartz"
        } rounded-0`} // applying the grid theme
        style={{ height: "100vh" }} // the grid will fill the size of the parent container
      >
        <Card className="h-100">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Patients</h5>
            <div className="d-flex gap-2">
              <Form action="#" className="position-relative">
                <Form.Control
                  type="search"
                  placeholder="Search..."
                  id="filter-text-box"
                  aria-label="Search"
                  className=" search-input py-1"
                  onInput={onFilterTextBoxChanged}
                />
              </Form>

              {/* <div className="example-header">
                <input
                  type="text"
                  id="filter-text-box"
                  placeholder="Search"
                  onInput={onFilterTextBoxChanged}
                />
              </div> */}
              <OverlayTrigger
                overlay={
                  <Tooltip
                    style={{ position: "fixed" }}
                    id="overlay-trigger-example"
                  >
                    New
                  </Tooltip>
                }
              >
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="plus"
                  transform="shrink-3"
                  onClick={() => navigate(CONSTANT_ROUTES.ADD_NEW_PATIENT)}
                >
                  <span className="d-none d-sm-inline-block ms-1">New</span>
                </IconButton>
              </OverlayTrigger>
              <TableHeaderDropdown>
                <div className="py-2">
                  <Dropdown.Item
                    onClick={saveState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Save State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={restoreState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Restore State
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={resetState}
                    className="d-flex align-items-center gap-2 py-2"
                  >
                    Reset State
                  </Dropdown.Item>
                </div>
              </TableHeaderDropdown>
            </div>
          </Card.Header>

          <Card.Body className="p-0">
            <AgGridReact
              // rowData={rowData}
              ref={columnApiRef}
              onGridReady={onGridReady}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              // pagination={true}
              onRowDoubleClicked={(params) => handleRowClick(params.data)}
              rowStyle={{ cursor: "pointer" }}
              overlayNoRowsTemplate="Nothing found - Looks empty over here"
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
